var map = {
	"./abbank.png": 100,
	"./acb.png": 101,
	"./agribank.png": 102,
	"./baca.png": 103,
	"./baoviet.png": 104,
	"./bidv.png": 105,
	"./citi.png": 106,
	"./daia.png": 107,
	"./donga.png": 108,
	"./eximbank.png": 109,
	"./fe.png": 110,
	"./gpbank.png": 111,
	"./hdbank.png": 112,
	"./hsbc.png": 113,
	"./ivb.png": 114,
	"./kienlong.png": 115,
	"./lienviet.png": 116,
	"./maritime.png": 117,
	"./mb.png": 118,
	"./mekong.png": 119,
	"./nama.png": 120,
	"./navi.png": 121,
	"./ocb.png": 122,
	"./ocean.png": 123,
	"./pgbank.png": 124,
	"./publicbank.png": 125,
	"./sacombank.png": 126,
	"./saigon.png": 127,
	"./scb.png": 128,
	"./seabank.png": 129,
	"./shb.png": 130,
	"./shinhan.png": 131,
	"./standard.png": 132,
	"./techcombank.png": 133,
	"./tpbank.png": 134,
	"./vib.png": 135,
	"./vieta.png": 136,
	"./vietbank.png": 137,
	"./vietcapital.png": 138,
	"./vietcombank.png": 139,
	"./viettinbank.png": 140,
	"./vpbank.png": 141,
	"./vrb.png": 142,
	"./westernbank.png": 143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;